// extracted by mini-css-extract-plugin
export default {"selectContainer":"SelectLanguage_selectContainer__3W2AL"};